import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import chatbotEventAccessApi from "../../api/chatbotEventAccessApi";

export const fetchChatbotEventAccess = createAsyncThunk(
  "chatbotEventAccess/fetch",
  async (accountId, { rejectWithValue }) => {
    try {
      const result = await chatbotEventAccessApi.getMyAccess(accountId);
      if (result.status === 1) {
        return result.data;
      }
      return rejectWithValue(result.message || "Không tải được quyền truy cập");
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Có lỗi xảy ra",
      );
    }
  },
);

const chatbotEventAccessSlice = createSlice({
  name: "chatbotEventAccess",
  initialState: {
    accountId: null,
    enabled: null,
    loading: false,
    loaded: false,
    error: null,
  },
  reducers: {
    resetChatbotEventAccess: (state) => {
      state.accountId = null;
      state.enabled = null;
      state.loading = false;
      state.loaded = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatbotEventAccess.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.accountId = Number(action.meta.arg) || null;
      })
      .addCase(fetchChatbotEventAccess.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.accountId = action.payload?.accountId ?? state.accountId;
        state.enabled = action.payload?.enabled === true;
      })
      .addCase(fetchChatbotEventAccess.rejected, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.enabled = false;
        state.error = action.payload || "Không tải được quyền truy cập";
      });
  },
});

export const { resetChatbotEventAccess } = chatbotEventAccessSlice.actions;

export default chatbotEventAccessSlice.reducer;
